// robotEvents.js - 适配现有目录结构的数据拆分版

// 缓存已加载的数据
const eventCache = {
  day: {},
  night: {}
};

// 加载CSV文件的函数
const loadCsvFile = async (robotId, timeKey) => {
  try {
    // 使用现有的目录结构
    const filePath = `/${timeKey}/robot${robotId}.csv`;
    
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error(`加载失败: ${response.status}`);
    }
    
    const csvContent = await response.text();
    eventCache[timeKey][robotId] = csvContent;
    return csvContent;
  } catch (error) {
    // console.error(`无法加载机器人${robotId}的${timeKey}数据:`, error);
    // 返回一个有效的空CSV头
    return "Type,Event,frame_start,frame_end,probability,summary,image_path,bboxes,similarVideos";
  }
};

// 预加载常用机器人数据
const preloadCommonRobots = () => {
  // 预加载前9个机器人数据
  for (let i = 1; i <= 9; i++) {
    loadCsvFile(i, 'day');
    loadCsvFile(i, 'night');
  }
};

// 应用初始化时调用
preloadCommonRobots();

// 保持原有API接口不变
export const getRobotEvents = (robotId, timeframe = "11AM") => {
  const timeKey = timeframe === "11AM" ? "day" : "night";
  
  // 如果缓存中有数据，直接返回
  if (eventCache[timeKey][robotId]) {
    return eventCache[timeKey][robotId];
  }
  
  // 触发异步加载，但返回暂时的空数据结构
  loadCsvFile(robotId, timeKey).then(() => {
    // console.log(`机器人${robotId}的${timeKey}数据已加载到缓存`);
  });
  
  // 返回默认头部，确保调用方不会崩溃
  return "Type,Event,frame_start,frame_end,probability,summary,justification,image_path,bboxes,similarVideos";
};

// 为了向后兼容，导出一个空对象
const robotEvents = {
  day: {},
  night: {}
};

export default robotEvents;
export { loadCsvFile };
